import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

import { AccessPointType } from "../../../../../../apis/networkdashboard/graphql/graphql";
import { WirelessHealthDetail } from "../../../../../../apis/networkdashboard/rest/models";
import { UserStatsComponent } from "../../../../../../components/subscription-detail/user-stats/user-stats";
import { AccessPoints } from "../access-points/access-points";

@Component({
  selector: "access-points-section",
  templateUrl: "access-points-section.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AccessPoints, AngularSvgIconModule, TranslatePipe, UserStatsComponent],
})
export class AccessPointsSectionComponent {
  protected accessPoints = input.required<AccessPointType[]>();
  protected kpis = input.required<WirelessHealthDetail>();
  protected apCountsByModel = computed(() => this.kpis().apCountsByModel);
}
